import { onBeforeUnmount } from 'vue'
import { useRealtimeStore } from '@/stores/realtime'
import type { RealtimeEvent, RealtimeMessage } from '@/stores/realtime'

export interface RealtimeOptions {
  /**
   * Sdruží rychle jdoucí události do jednoho volání. Statistiky se mění při
   * každé návštěvě stránky, bez sdružení by se seznam načítal pořád dokola.
   */
  debounceMs?: number
}

/**
 * Přihlásí obsluhu událostí na dobu života komponenty. Odregistrace
 * i zrušení naplánovaného volání proběhne automaticky při odpojení.
 */
export function useRealtime(
  events: RealtimeEvent[],
  handler: (message: RealtimeMessage) => void,
  options: RealtimeOptions = {},
): void {
  const realtime = useRealtimeStore()
  const { debounceMs = 0 } = options

  let timer: ReturnType<typeof setTimeout> | undefined

  const wrapped = (message: RealtimeMessage): void => {
    if (debounceMs <= 0) {
      handler(message)
      return
    }

    clearTimeout(timer)
    timer = setTimeout(() => handler(message), debounceMs)
  }

  const off = realtime.onAny(events, wrapped)

  onBeforeUnmount(() => {
    clearTimeout(timer)
    off()
  })
}
